/**
 * Rewrites the hostname of a URL configured for `localhost` / `127.0.0.1`
 * to match the host that actually served the page, when that host is a
 * LAN IP. This lets a teammate open the dev server from another device
 * on the same Wi-Fi/LAN (the CRA "On Your Network" URL) and still reach
 * the backend without changing any env files.
 *
 * Falls through unchanged when:
 *   - running outside the browser (SSR/tests)
 *   - the page itself was loaded from localhost
 *   - the configured URL already points at a non-localhost host
 *   - the input is not a parseable absolute URL
 */
export const resolveLanUrl = (rawUrl: string): string => {
  if (!rawUrl || typeof window === 'undefined') return rawUrl;

  const pageHost = window.location.hostname;
  const isLanPage = pageHost !== 'localhost' && pageHost !== '127.0.0.1';
  if (!isLanPage) return rawUrl;

  try {
    const u = new URL(rawUrl);
    if (u.hostname === 'localhost' || u.hostname === '127.0.0.1') {
      u.hostname = pageHost;
      const rebuilt = u.toString();
      return rawUrl.endsWith('/') ? rebuilt : rebuilt.replace(/\/$/, '');
    }
  } catch {
    /* not an absolute URL – leave as-is */
  }
  return rawUrl;
};
